import styled from 'styled-components';
import theme from 'styled-theming';

const linkColor = theme('mode', {
  light: (props) => props.theme.colors.brightRichBlue,
  dark: (props) => props.theme.colors.aqua,
});

const Link = styled.a`color: ${linkColor};`;

export default Link;
